import { MACHINE_READABLE_LINKS, SITE_MAP_LINKS, SITE_URL } from "@/lib/markdown-pages"

/**
 * The recovery map rendered into the 404 page.
 *
 * An agent that lands on a 404 needs somewhere to go next, and it reads the HTML
 * body — so the same links the markdown 404 lists are emitted here as real
 * anchors. The existing 404 art direction is untouched: this renders below the
 * card as small, muted, on-brand text.
 */
export function AgentRecoveryMap() {
  return (
    <section
      aria-labelledby="recovery-map-heading"
      className="relative mx-auto mt-12 w-full max-w-3xl px-6 pb-16 text-left"
      data-agent-recovery-map=""
    >
      <h2
        id="recovery-map-heading"
        className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-white/40"
      >
        Where to go next
      </h2>

      <ul className="grid gap-x-8 gap-y-2 sm:grid-cols-2">
        {SITE_MAP_LINKS.map(({ path, label, description }) => (
          <li key={path} className="text-sm leading-relaxed">
            <a
              href={path}
              className="font-medium text-white/70 underline-offset-4 transition-colors hover:text-white hover:underline"
            >
              {label}
            </a>
            <span className="text-white/40"> — {description}</span>
          </li>
        ))}
      </ul>

      <h2 className="mb-3 mt-8 text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
        Machine-readable
      </h2>
      <ul className="grid gap-x-8 gap-y-2 sm:grid-cols-2">
        {MACHINE_READABLE_LINKS.map(({ path, description }) => (
          <li key={path} className="text-sm leading-relaxed">
            <a
              href={path}
              className="font-mono text-white/60 underline-offset-4 transition-colors hover:text-white hover:underline"
            >
              {path}
            </a>
            <span className="text-white/40"> — {description}</span>
          </li>
        ))}
      </ul>

      <p className="mt-8 text-xs leading-relaxed text-white/30">
        This page is a real HTTP 404. Request any page with{" "}
        <code className="font-mono">Accept: text/markdown</code> for a markdown
        representation, or read{" "}
        <a href="/llms.txt" className="underline underline-offset-4 hover:text-white/60">
          {SITE_URL}/llms.txt
        </a>{" "}
        for a site overview.
      </p>
    </section>
  )
}
